// AUTO-GENERATED from services/radar-render/sites.py — do not edit by hand.
// Regenerate: node scripts/gen-sites.mjs  (parses the service site table → this array).
// The authoritative NEXRAD WSR-88D site table (id, name, lat, lon).
import type { RadarSite } from "./sites"

export const SITE_TABLE: RadarSite[] = [
  { id: "KABR", name: "Aberdeen, SD", lat: 45.456, lon: -98.413 },
  { id: "KABX", name: "Albuquerque, NM", lat: 35.150, lon: -106.824 },
  { id: "KAKQ", name: "Wakefield, VA", lat: 36.984, lon: -77.007 },
  { id: "KAMA", name: "Amarillo, TX", lat: 35.233, lon: -101.709 },
  { id: "KAMX", name: "Miami, FL", lat: 25.611, lon: -80.413 },
  { id: "KAPX", name: "Gaylord, MI", lat: 44.907, lon: -84.720 },
  { id: "KARX", name: "La Crosse, WI", lat: 43.823, lon: -91.191 },
  { id: "KATX", name: "Seattle/Tacoma, WA", lat: 48.195, lon: -122.496 },
  { id: "KBBX", name: "Beale AFB, CA", lat: 39.496, lon: -121.632 },
  { id: "KBGM", name: "Binghamton, NY", lat: 42.200, lon: -75.985 },
  { id: "KBHX", name: "Eureka, CA", lat: 40.499, lon: -124.292 },
  { id: "KBIS", name: "Bismarck, ND", lat: 46.771, lon: -100.760 },
  { id: "KBLX", name: "Billings, MT", lat: 45.854, lon: -108.607 },
  { id: "KBMX", name: "Birmingham, AL", lat: 33.172, lon: -86.770 },
  { id: "KBOX", name: "Boston, MA", lat: 41.956, lon: -71.137 },
  { id: "KBRO", name: "Brownsville, TX", lat: 25.916, lon: -97.419 },
  { id: "KBUF", name: "Buffalo, NY", lat: 42.949, lon: -78.737 },
  { id: "KBYX", name: "Key West, FL", lat: 24.598, lon: -81.703 },
  { id: "KCAE", name: "Columbia, SC", lat: 33.949, lon: -81.118 },
  { id: "KCBW", name: "Caribou, ME", lat: 46.039, lon: -67.806 },
  { id: "KCBX", name: "Boise, ID", lat: 43.490, lon: -116.236 },
  { id: "KCCX", name: "State College, PA", lat: 40.923, lon: -78.004 },
  { id: "KCLE", name: "Cleveland, OH", lat: 41.413, lon: -81.860 },
  { id: "KCLX", name: "Charleston, SC", lat: 32.656, lon: -81.042 },
  { id: "KCRP", name: "Corpus Christi, TX", lat: 27.784, lon: -97.511 },
  { id: "KCXX", name: "Burlington, VT", lat: 44.511, lon: -73.167 },
  { id: "KCYS", name: "Cheyenne, WY", lat: 41.152, lon: -104.806 },
  { id: "KDAX", name: "Sacramento, CA", lat: 38.501, lon: -121.678 },
  { id: "KDDC", name: "Dodge City, KS", lat: 37.761, lon: -99.969 },
  { id: "KDFX", name: "Laughlin AFB, TX", lat: 29.273, lon: -100.281 },
  { id: "KDGX", name: "Jackson, MS", lat: 32.280, lon: -89.984 },
  { id: "KDIX", name: "Philadelphia, PA", lat: 39.947, lon: -74.411 },
  { id: "KDLH", name: "Duluth, MN", lat: 46.837, lon: -92.210 },
  { id: "KDMX", name: "Des Moines, IA", lat: 41.731, lon: -93.723 },
  { id: "KDOX", name: "Dover AFB, DE", lat: 38.826, lon: -75.440 },
  { id: "KDTX", name: "Detroit, MI", lat: 42.700, lon: -83.472 },
  { id: "KDVN", name: "Davenport, IA", lat: 41.612, lon: -90.581 },
  { id: "KDYX", name: "Dyess AFB, TX", lat: 32.538, lon: -99.254 },
  { id: "KEAX", name: "Kansas City, MO", lat: 38.810, lon: -94.264 },
  { id: "KEMX", name: "Tucson, AZ", lat: 31.894, lon: -110.630 },
  { id: "KENX", name: "Albany, NY", lat: 42.586, lon: -74.064 },
  { id: "KEOX", name: "Fort Rucker, AL", lat: 31.460, lon: -85.459 },
  { id: "KEPZ", name: "El Paso, TX", lat: 31.873, lon: -106.698 },
  { id: "KESX", name: "Las Vegas, NV", lat: 35.701, lon: -114.891 },
  { id: "KEVX", name: "Eglin AFB, FL", lat: 30.564, lon: -85.921 },
  { id: "KEWX", name: "Austin/San Antonio, TX", lat: 29.704, lon: -98.029 },
  { id: "KEYX", name: "Edwards AFB, CA", lat: 35.098, lon: -117.561 },
  { id: "KFCX", name: "Roanoke, VA", lat: 37.024, lon: -80.274 },
  { id: "KFDR", name: "Frederick, OK", lat: 34.362, lon: -98.976 },
  { id: "KFDX", name: "Cannon AFB, NM", lat: 34.635, lon: -103.630 },
  { id: "KFFC", name: "Atlanta, GA", lat: 33.364, lon: -84.566 },
  { id: "KFSD", name: "Sioux Falls, SD", lat: 43.588, lon: -96.729 },
  { id: "KFSX", name: "Flagstaff, AZ", lat: 34.574, lon: -111.198 },
  { id: "KFTG", name: "Denver, CO", lat: 39.787, lon: -104.546 },
  { id: "KFWS", name: "Dallas/Fort Worth, TX", lat: 32.573, lon: -97.303 },
  { id: "KGGW", name: "Glasgow, MT", lat: 48.206, lon: -106.625 },
  { id: "KGJX", name: "Grand Junction, CO", lat: 39.062, lon: -108.214 },
  { id: "KGLD", name: "Goodland, KS", lat: 39.367, lon: -101.700 },
  { id: "KGRB", name: "Green Bay, WI", lat: 44.498, lon: -88.111 },
  { id: "KGRK", name: "Fort Hood, TX", lat: 30.722, lon: -97.383 },
  { id: "KGRR", name: "Grand Rapids, MI", lat: 42.894, lon: -85.545 },
  { id: "KGSP", name: "Greer, SC", lat: 34.883, lon: -82.220 },
  { id: "KGWX", name: "Columbus AFB, MS", lat: 33.897, lon: -88.329 },
  { id: "KGYX", name: "Portland, ME", lat: 43.891, lon: -70.256 },
  { id: "KHDX", name: "Holloman AFB, NM", lat: 33.077, lon: -106.123 },
  { id: "KHGX", name: "Houston, TX", lat: 29.472, lon: -95.079 },
  { id: "KHNX", name: "San Joaquin Valley, CA", lat: 36.314, lon: -119.632 },
  { id: "KHPX", name: "Fort Campbell, KY", lat: 36.737, lon: -87.285 },
  { id: "KHTX", name: "Huntsville, AL", lat: 34.931, lon: -86.084 },
  { id: "KICT", name: "Wichita, KS", lat: 37.655, lon: -97.443 },
  { id: "KICX", name: "Cedar City, UT", lat: 37.591, lon: -112.862 },
  { id: "KILN", name: "Cincinnati, OH", lat: 39.420, lon: -83.822 },
  { id: "KILX", name: "Lincoln, IL", lat: 40.151, lon: -89.337 },
  { id: "KIND", name: "Indianapolis, IN", lat: 39.708, lon: -86.280 },
  { id: "KINX", name: "Tulsa, OK", lat: 36.175, lon: -95.565 },
  { id: "KIWA", name: "Phoenix, AZ", lat: 33.289, lon: -111.670 },
  { id: "KIWX", name: "Northern Indiana", lat: 41.359, lon: -85.700 },
  { id: "KJAX", name: "Jacksonville, FL", lat: 30.485, lon: -81.702 },
  { id: "KJGX", name: "Robins AFB, GA", lat: 32.675, lon: -83.351 },
  { id: "KJKL", name: "Jackson, KY", lat: 37.591, lon: -83.313 },
  { id: "KLBB", name: "Lubbock, TX", lat: 33.654, lon: -101.814 },
  { id: "KLCH", name: "Lake Charles, LA", lat: 30.125, lon: -93.216 },
  { id: "KLGX", name: "Langley Hill, WA", lat: 47.117, lon: -124.107 },
  { id: "KLIX", name: "New Orleans, LA", lat: 30.337, lon: -89.825 },
  { id: "KLNX", name: "North Platte, NE", lat: 41.958, lon: -100.576 },
  { id: "KLOT", name: "Chicago, IL", lat: 41.605, lon: -88.085 },
  { id: "KLRX", name: "Elko, NV", lat: 40.740, lon: -116.803 },
  { id: "KLSX", name: "St. Louis, MO", lat: 38.699, lon: -90.683 },
  { id: "KLTX", name: "Wilmington, NC", lat: 33.989, lon: -78.429 },
  { id: "KLVX", name: "Louisville, KY", lat: 37.975, lon: -85.944 },
  { id: "KLWX", name: "Sterling, VA", lat: 38.976, lon: -77.478 },
  { id: "KLZK", name: "Little Rock, AR", lat: 34.836, lon: -92.262 },
  { id: "KMAF", name: "Midland/Odessa, TX", lat: 31.943, lon: -102.189 },
  { id: "KMAX", name: "Medford, OR", lat: 42.081, lon: -122.717 },
  { id: "KMBX", name: "Minot AFB, ND", lat: 48.393, lon: -100.865 },
  { id: "KMHX", name: "Morehead City, NC", lat: 34.776, lon: -76.876 },
  { id: "KMKX", name: "Milwaukee, WI", lat: 42.968, lon: -88.551 },
  { id: "KMLB", name: "Melbourne, FL", lat: 28.113, lon: -80.654 },
  { id: "KMOB", name: "Mobile, AL", lat: 30.679, lon: -88.240 },
  { id: "KMPX", name: "Minneapolis, MN", lat: 44.849, lon: -93.565 },
  { id: "KMQT", name: "Marquette, MI", lat: 46.531, lon: -87.548 },
  { id: "KMRX", name: "Knoxville, TN", lat: 36.168, lon: -83.402 },
  { id: "KMSX", name: "Missoula, MT", lat: 47.041, lon: -113.986 },
  { id: "KMTX", name: "Salt Lake City, UT", lat: 41.263, lon: -112.448 },
  { id: "KMUX", name: "San Francisco, CA", lat: 37.155, lon: -121.898 },
  { id: "KMVX", name: "Grand Forks, ND", lat: 47.528, lon: -97.326 },
  { id: "KMXX", name: "Maxwell AFB, AL", lat: 32.537, lon: -85.790 },
  { id: "KNKX", name: "San Diego, CA", lat: 32.919, lon: -117.042 },
  { id: "KNQA", name: "Memphis, TN", lat: 35.345, lon: -89.873 },
  { id: "KOAX", name: "Omaha, NE", lat: 41.320, lon: -96.367 },
  { id: "KOHX", name: "Nashville, TN", lat: 36.247, lon: -86.563 },
  { id: "KOKX", name: "New York City, NY", lat: 40.866, lon: -72.864 },
  { id: "KOTX", name: "Spokane, WA", lat: 47.681, lon: -117.627 },
  { id: "KPAH", name: "Paducah, KY", lat: 37.068, lon: -88.772 },
  { id: "KPBZ", name: "Pittsburgh, PA", lat: 40.532, lon: -80.218 },
  { id: "KPDT", name: "Pendleton, OR", lat: 45.691, lon: -118.853 },
  { id: "KPOE", name: "Fort Polk, LA", lat: 31.156, lon: -92.976 },
  { id: "KPUX", name: "Pueblo, CO", lat: 38.460, lon: -104.181 },
  { id: "KRAX", name: "Raleigh/Durham, NC", lat: 35.666, lon: -78.490 },
  { id: "KRGX", name: "Reno, NV", lat: 39.754, lon: -119.462 },
  { id: "KRIW", name: "Riverton, WY", lat: 43.066, lon: -108.477 },
  { id: "KRLX", name: "Charleston, WV", lat: 38.311, lon: -81.723 },
  { id: "KRTX", name: "Portland, OR", lat: 45.715, lon: -122.965 },
  { id: "KSFX", name: "Pocatello, ID", lat: 43.106, lon: -112.686 },
  { id: "KSGF", name: "Springfield, MO", lat: 37.235, lon: -93.401 },
  { id: "KSHV", name: "Shreveport, LA", lat: 32.451, lon: -93.841 },
  { id: "KSJT", name: "San Angelo, TX", lat: 31.371, lon: -100.493 },
  { id: "KSOX", name: "Santa Ana Mtns, CA", lat: 33.818, lon: -117.636 },
  { id: "KSRX", name: "Fort Smith, AR", lat: 35.290, lon: -94.362 },
  { id: "KTBW", name: "Tampa Bay, FL", lat: 27.706, lon: -82.402 },
  { id: "KTFX", name: "Great Falls, MT", lat: 47.460, lon: -111.385 },
  { id: "KTLH", name: "Tallahassee, FL", lat: 30.398, lon: -84.329 },
  { id: "KTLX", name: "Oklahoma City, OK", lat: 35.333, lon: -97.278 },
  { id: "KTWX", name: "Topeka, KS", lat: 38.997, lon: -96.232 },
  { id: "KTYX", name: "Fort Drum, NY", lat: 43.756, lon: -75.680 },
  { id: "KUDX", name: "Rapid City, SD", lat: 44.125, lon: -102.830 },
  { id: "KUEX", name: "Hastings, NE", lat: 40.321, lon: -98.442 },
  { id: "KVAX", name: "Moody AFB, GA", lat: 30.890, lon: -83.002 },
  { id: "KVBX", name: "Vandenberg AFB, CA", lat: 34.838, lon: -120.398 },
  { id: "KVNX", name: "Vance AFB, OK", lat: 36.741, lon: -98.128 },
  { id: "KVTX", name: "Los Angeles, CA", lat: 34.412, lon: -119.179 },
  { id: "KVWX", name: "Evansville, IN", lat: 38.260, lon: -87.725 },
  { id: "KYUX", name: "Yuma, AZ", lat: 32.495, lon: -114.657 },
  { id: "PABC", name: "Bethel, AK", lat: 60.792, lon: -161.876 },
  { id: "PAEC", name: "Nome, AK", lat: 64.511, lon: -165.295 },
  { id: "PAHG", name: "Anchorage, AK", lat: 60.726, lon: -151.351 },
  { id: "PAIH", name: "Middleton Is., AK", lat: 59.461, lon: -146.303 },
  { id: "PAKC", name: "King Salmon, AK", lat: 58.679, lon: -156.629 },
  { id: "PAPD", name: "Fairbanks, AK", lat: 65.035, lon: -147.501 },
  { id: "PHKI", name: "Kauai, HI", lat: 21.894, lon: -159.552 },
  { id: "PHKM", name: "Kohala, HI", lat: 20.125, lon: -155.778 },
  { id: "PHMO", name: "Molokai, HI", lat: 21.133, lon: -157.180 },
  { id: "PHWA", name: "South Shore, HI", lat: 19.095, lon: -155.569 },
  { id: "TJUA", name: "San Juan, PR", lat: 18.116, lon: -66.078 },
  { id: "PGUA", name: "Andersen AFB, Guam", lat: 13.456, lon: 144.811 },
]
